define('home/views/NotificationCardAddModView',[
    'underscore',

    'home/models/Session',
    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',
    'home/mixins/withChannelAvatar',
    'core/mixins/withForumFollowing',
    'home/utils/confirmModal',
    'home/templates/notificationCardAddMod',
    'home/templates/confirmResignModerator',
], function (
    _,

    Session,
    ActivityCardView,
    withReason,
    asNotificationCard,
    withChannelAvatar,
    withForumFollowing,
    confirmModal,
    notificationCardAddModTemplate,
    confirmResignModeratorTemplate
) {
    'use strict';

    var parent = ActivityCardView;


    /**
     * A notification card when the session user has been added as a moderator to a channel or forum.
     * Shows the channels/forums and appropriate actions (ex: (un)follow channel/forum, (un)moderate channel/forum).
     *
     * Expects an ActivityFeedItem as a model. Only displays the first activity, which should have
     * a Forum as the target.
     */
    var NotificationCardAddModView = parent.extend({
        className: 'card-notif-add-mod',

        events: {
            'click [data-action=remove-moderator]': 'confirmRemoveModerator',
        },

        initialize: function () {
            this.session = Session.get();
            this.forum = this.getForum();
            this.channel = this.forum.channel;

            // Re render after fetching user's moderated forums so we can show
            // whether or not the user is still a moderator for this channel or forum
            this.session.loadModeratedForums().then(_.bind(this.render, this));
        },

        template: notificationCardAddModTemplate,
        templateHelpers: function () {
            return {
                forum: this.forum.toJSON(),
                resigned: !this.sessionUserIsModerator(),
            };
        },

        sessionUserIsModerator: function () {
            return _.contains(this.session.user.get('moderatedForums'), this.forum.id);
        },

        confirmRemoveModerator: function (evt) {
            if (evt)
                evt.preventDefault();

            var channelOrForumName = this.channel && this.channel.attributes.name || this.forum.attributes.name;

            confirmModal.confirmationPromise(
                confirmModal.TYPES.CONFIRM_CANCEL,
                confirmResignModeratorTemplate({ name: channelOrForumName })
            ).then(_.bind(this.removeModerator, this));
        },

        removeModerator: function (isConfirmed) {
            if (!isConfirmed)
                return;

            if (this.channel) {
                this.session.user.moderateChannel(this.channel, false)
                    .then(_.bind(this.render, this));
            }
            else {
                this.session.user.moderateForum(this.forum, false)
                    .then(_.bind(this.render, this));
            }
        },

        getForum: function () {
            // Add Mod activities shouldn't be grouped, so just use the forum
            // from the first activity
            return this.model.activities[0].target;
        },
    });


    var proto = NotificationCardAddModView.prototype;
    withReason.call(proto);
    asNotificationCard.call(proto);

    var getChannel = function () {
        return this.forum && this.forum.channel;
    };

    var getForum = function () {
        return this.forum;
    };

    withChannelAvatar.call(proto, getChannel);

    withForumFollowing.call(proto, getForum);

    return NotificationCardAddModView;
});

